/*
----------------------------------------------------
  FUNCTION TO CHECK FOR QUESTIONS AND QUIZZES
----------------------------------------------------
*/
/* eslint-disable*/

var checkSoaPSubscription = function checkSoaPSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  var pdfFlag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            if (exam_data[i].levels[j].isActive) {
              flag = true;
              break;
            }
          } else {
            /*
            --------------
              App User's
            --------------
            */
            if (exam_data[i].levels[j].isActive) {
              flag = true;
              break;
            }
          }
        }
      } else {
        flag = true;
      }
      break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              flag = true;
              break;
            }
          } else {
            /*
            --------------
             App User's
            --------------
            */
            if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              (exam_data[i].levels[j].package_id === 31 ||
                exam_data[i].levels[j].package_id === 34 ||
                exam_data[i].levels[j].package_id === 36)
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
  }

  return flag;
};

/*
-------------------------------------------
  Function to check for notes subscription
-------------------------------------------
*/

var checkSoaPNotesSubscription = function checkSoaPNotesSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");

    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            }
          } else {
            /*
            ---------------
              App User's
            ---------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              break;
            }
          }
        }
      } else {
        // console.log("6");
        flag = true;
      }
      // break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */

            if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35 &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            }
          } else {
            /*
          --------------
            App User's
          --------------
          */
            if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              (exam_data[i].levels[j].package_id === 31 ||
                exam_data[i].levels[j].package_id === 34 ||
                exam_data[i].levels[j].package_id === 36)
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35 &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              flag = true;
              break;
            }
          }
        }
      }
    }
  }

  return flag;
};

/*
----------------------------------------------
  FUNCTION TO CHECK FOR PDF'S SUBSCRIPTION
----------------------------------------------
*/
var checkSoaP_PDFSubscription = function checkSoaP_PDFSubscription(
  selectedLevel,
  exam_data,
  type
) {
  var pdfFlag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            -------------------
            */
            // inside if block check  for the partner user subscription
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              pdfFlag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                pdfFlag = true;
              }
              // break;/
            }
          } else {
            /*
            --------------
              App user's
            --------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              pdfFlag = true;
              // break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                pdfFlag = true;
              }
              // break;/
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive
            ) {
              pdfFlag = true;
              // break;
            }
          }
        }
      } else {
        pdfFlag = true;
      }
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            -------------------
            */

            if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                pdfFlag = true;
              }
              // break;
            }
          } else {
            /*
            ----------------
              App User's
            ----------------
            */
            if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              (exam_data[i].levels[j].package_id === 31 ||
                exam_data[i].levels[j].package_id === 34 ||
                exam_data[i].levels[j].package_id === 36)
            ) {
              pdfFlag = true;
            } else if (
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].package_id === 35
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                pdfFlag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                pdfFlag = true;
              }
              // break;
            }
          }
        }
      }
    }
  }

  return pdfFlag;
};

exports.checkSoaPSubscription = checkSoaPSubscription;
exports.checkSoaPNotesSubscription = checkSoaPNotesSubscription;
exports.checkSoaP_PDFSubscription = checkSoaP_PDFSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/PartnerSubscription/SoaPSubscription.js